import type { Rate } from "../types";

export function RatesField({
  value,
  onChange,
}: {
  value: Rate[];
  onChange: (v: Rate[]) => void;
}) {
  function update(idx: number, next: Rate) {
    onChange(value.map((r, i) => (i === idx ? next : r)));
  }
  function remove(idx: number) {
    onChange(value.filter((_, i) => i !== idx));
  }
  function add() {
    onChange([...value, { label: "New product", grossPct: 0, aerPct: 0 }]);
  }

  return (
    <div className="space-y-2">
      {value.map((r, i) => (
        <div key={i} className="grid grid-cols-[1fr_5rem_5rem_auto] gap-2 items-center">
          <input
            value={r.label}
            onChange={(e) => update(i, { ...r, label: e.target.value })}
            className="rounded border px-2 py-1.5 text-sm"
          />
          <input
            type="number"
            step="0.01"
            value={r.grossPct}
            onChange={(e) => update(i, { ...r, grossPct: parseFloat(e.target.value) || 0 })}
            className="rounded border px-2 py-1.5 text-sm text-right"
            title="Gross %"
          />
          <input
            type="number"
            step="0.01"
            value={r.aerPct}
            onChange={(e) => update(i, { ...r, aerPct: parseFloat(e.target.value) || 0 })}
            className="rounded border px-2 py-1.5 text-sm text-right"
            title="AER %"
          />
          <button
            type="button"
            onClick={() => remove(i)}
            className="text-xs text-neutral-500 hover:text-red-600 px-2"
            title="Remove rate"
          >
            ✕
          </button>
        </div>
      ))}
      <div className="flex justify-between text-[11px] text-neutral-400 pt-1 px-1">
        <span>Label</span>
        <span className="pr-32">Gross %</span>
        <span className="pr-12">AER %</span>
      </div>
      <button
        type="button"
        onClick={add}
        className="text-sm text-neutral-700 hover:text-neutral-900 underline"
      >
        + Add rate
      </button>
    </div>
  );
}
